<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" :title="title" width="500" >
      <el-form  :model="formInline" class="demo-form-inline">
        <el-form-item label="平台名称">
          <el-input style="width:200px" disabled v-model="formInline.platformName" placeholder="请输入店铺名称" clearable />
        </el-form-item>
        <el-form-item label="站点名称">
          <el-input style="width:200px" disabled v-model="formInline.amazonsite" placeholder="请输入站点名称" clearable />
        </el-form-item>
        <el-form-item label="店铺名称">
          <el-input style="width:200px" disabled v-model="formInline.shopName" placeholder="请输入店铺名称" clearable />
        </el-form-item>
        <el-form-item label="默认年限">
          <el-input style="width:200px" type="number" v-model="formInline.shopDefaultYear" placeholder="请输入默认年限" clearable />
        </el-form-item>
        <el-form-item label="店铺状态">
          <el-select
              disabled
              style="width:200px"
              v-model="formInline.status"
              clearable
              placeholder="请选择店铺状态"
          >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item >
          <el-button style="margin: 0 auto" type="primary" @click="onSubmit">{{botton}}</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>
  </div>
</template>
<script >
import {ElDialog, ElForm, ElFormItem, ElButton, ElInput, ElSelect, ElOption, ElMessage} from "element-plus";
import {addBaseShopList} from "@/utils/api";
export default {
  name: "addShopList",
  components:{
    ElDialog,ElForm,ElFormItem,ElButton,ElInput,ElSelect,ElOption
  },
  data(){
    return{
      dialogTableVisible:false,
      title:"新建店铺",
      botton:"创建店铺",
      formInline:{
        order:10,
        status:true
      },
      options:[
        {
          value:true,
          label: '正常',
        },
        {
          value: false,
          label: '禁用',
        },
      ]
    }
  },
  methods:{
    open(data){
      console.log(data)
      this.dialogTableVisible = true
      if(data && data.id){
        this.title = "编辑店铺"
        this.botton = "确认编辑"
        this.formInline = data
      }else{
        this.title = "新建店铺"
        this.botton = "创建店铺"
        this.formInline = {
          order:10,
          status:true
        }
      }
    },
    onSubmit(){
      if(!this.formInline.shopDefaultYear){
        ElMessage.warning('请填写默认年限')
        return false
      }
      addBaseShopList(this.formInline).then((res)=>{
        console.log(res)
        this.dialogTableVisible = false
        this.$emit('close')
      }).catch(err=>{
        console.log(err)
      })


    }
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 100px;
}
</style>